export default __webpack_public_path__ + "static/media/icon-status-complete.8e2ad133.svg";